export var AppEmbedData_AppType;
(function (AppEmbedData_AppType) {
    AppEmbedData_AppType["PRODUCT"] = "PRODUCT";
    AppEmbedData_AppType["EVENT"] = "EVENT";
    AppEmbedData_AppType["BOOKING"] = "BOOKING";
    AppEmbedData_AppType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AppEmbedData_AppType || (AppEmbedData_AppType = {}));
//# sourceMappingURL=plugin_app_embed.enums.js.map